import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./TextCardFragment.module.css";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type TextCardFragmentConfigProps = {
  field: string;
};

type TextCardFragmentProps = {
  configProps: TextCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function TextCardFragment({ configProps, commonProps }: TextCardFragmentProps) {
  const { field } = configProps;
  const { task } = commonProps;
  const text = getTypedValue<string>(getByPath(task, field));

  if (isLoading(text)) {
    return <LoadingCardFragment />;
  } else if (!text) {
    return null;
  }

  return <FixaText className={styles["root"]}>{text}</FixaText>;
}

export default TextCardFragment;
